import axios from 'axios'
import Prod_Domain_List from "@/utils/mappings/prodDomainList";

const STAGING_CONFIG = {
    PREF_CENTER_PROXY_URL : 'https://martel-stg2.sky.citrix.com/v1/endpoints/default/preference-center',
    PROGRAM_CODE: 'WW-0522-DAAS-Import-NewUnsubscribeForm'
}

const PROD_CONFIG = {
    PREF_CENTER_PROXY_URL : 'https://martel.sky.citrix.com/v1/endpoints/default/preference-center',
    PROGRAM_CODE: 'WW-0522-DAAS-Import-NewUnsubscribeForm'
}

const ENV_CONFIG = Prod_Domain_List.includes(window.location.hostname) ? PROD_CONFIG : STAGING_CONFIG;

export function submitData(endpoint, data, callback) {

    axios({
        url: ENV_CONFIG.PREF_CENTER_PROXY_URL,
        method: 'post',
        data: {
            ...data,
            programName: ENV_CONFIG.PROGRAM_CODE
        },
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(resp => {
        // console.log(resp)
        callback({
            "status": 200,
            "statusText": "thanks"
        })
    }).catch(e => {
        console.error('___ERROR___')
        console.error(e)
        console.error("___________")
        callback()
    })
}

